export default class Base64ImageTool {
    static get toolbox() {
        return {
            title: "Subir Imagem",
            icon: "<svg width='18' height='18' viewBox='0 0 24 24'><path d='M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM5 5h14v14H5V5zm2 12l3-4 2 3 3-4 4 5H7z'/></svg>",
        };
    }

    constructor({ data, api }) {
        this.api = api;
        this.data = data || {
            url: '',
            caption: '',
        };

        this.wrapper = undefined;
    }

    render() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("base64-image-tool-wrapper");

        if (this.data.url) {
            this._createImage();
        } else {
            const container = document.createElement("div");
            container.className = "upload-placeholder";

            const svgIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <path d="M21 15l-5-5L5 21"></path>
        </svg>
        `;


            const iconWrapper = document.createElement("div");
            iconWrapper.innerHTML = svgIcon;
            iconWrapper.style.marginBottom = "8px";

            const text = document.createElement("div");
            text.textContent = "Clique para enviar uma imagem";
            text.style.fontSize = "14px";
            text.style.color = "#4a4a4a";

            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*";
            input.style.display = "none";

            container.addEventListener("click", () => input.click());
            input.addEventListener("change", (event) => this._handleFile(event));

            container.appendChild(iconWrapper);
            container.appendChild(text);
            container.appendChild(input);

            this.wrapper.appendChild(container);
        }

        return this.wrapper;
    }

    _handleFile(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            this.data.url = reader.result;
            this.wrapper.innerHTML = ""; // limpar o input
            this._createImage();
        };
        reader.readAsDataURL(file);
    }

    _createImage() {
        const img = document.createElement("img");
        img.src = this.data.url;
        img.style.maxWidth = "100%";
        img.style.borderRadius = "4px";

        const caption = document.createElement("input");
        caption.type = "text";
        caption.placeholder = "Legenda da imagem";
        caption.value = this.data.caption || "";
        caption.style.width = "100%";
        caption.style.textAlign = "center";
        caption.addEventListener("input", (e) => {
            this.data.caption = e.target.value;
        });

        this.wrapper.appendChild(img);
        this.wrapper.appendChild(caption);
    }

    save() {
        return this.data;
    }

    validate(savedData) {
        return !!savedData.url;
    }
}
